import axios from 'axios'
import { getToken } from './auth'
import i18n from 'i18next'

const apiBaseURL = 'https://api.testeme.com.br'
// const apiBaseURL = 'http://localhost:8000'

export const api = axios.create({
  baseURL: `${apiBaseURL}`,
})

export const getManifestURL = (subdomain) => {
  return `${apiBaseURL}/api/v1/subdomain/${subdomain}/manifest/`
}

export const userLogin = (academy, slug, password) => {
  const url = '/api/v1/token/'
  return api.post(
    url,
    {
      academy: academy,
      slug: slug,
      password: password,
    },
    { headers: { 'Accept-Language': `${getBrowserLanguage()}` } },
  )
}

export const getSubdomainConfig = (subdomain) => {
  const url = `/api/v1/subdomain/${subdomain}/`
  return api.get(url, {
    headers: {
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getProfile = () => {
  const url = '/api/v1/profile/'
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const createS3Url = (data) => {
  const url = '/api/v1/upload/'
  return api.post(url, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getQuestions = (search, page) => {
  const url = `/api/v1/question/?search=${search}&page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getAuthors = (search, page) => {
  const url = `/api/v1/options/author/?search=${search}&page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getBoards = (search, page) => {
  const url = `/api/v1/options/board/?search=${search}&page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getTests = (search, page) => {
  const url = `/api/v1/options/test/?search=${search}&page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getFields = (search, page) => {
  const url = `/api/v1/options/field/?search=${search}&page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getDisciplines = (search) => {
  const url = `/api/v1/questions/fields/?search=${search}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getSubjects = (search, discipline) => {
  const url = `/api/v1/questions/subjects/?search=${search}&field=${discipline}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getRandomQuestion = (discipline, subject) => {
  const url = `/api/v1/questions/random/?field=${discipline}&subject=${subject || ''}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const answerQuestion = (questionId, id) => {
  const url = `/api/v1/questions/random/${questionId}/answer/`
  return api.post(
    url,
    {
      option_id: id,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': getBrowserLanguage(),
      },
    },
  )
}

// Aluno - Mock Tests
export const getMockTests = ({ page, pageSize }) => {
  const url = `/api/v1/tests/?page=${page}&page_size=${pageSize}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getMockTestQuestion = ({ testId, page }) => {
  const url = `/api/v1/tests/${testId}/questions/?page=${page}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const answerMockTestQuestion = ({ testId, questionId, answerId }) => {
  const url = `/api/v1/tests/${testId}/questions/${questionId}/answer/`
  return api.post(
    url,
    {
      option_id: answerId,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': getBrowserLanguage(),
      },
    },
  )
}

export const submitMockTest = (testId) => {
  const url = `/api/v1/tests/${testId}/finalize/`
  return api.post(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': `${getBrowserLanguage()}`,
      },
    },
  )
}

// Teacher - Mock Tests
export const getMockTestsTeacher = ({ page, pageSize, status }) => {
  const url = `/api/v1/teacher/tests/?page=${page}&page_size=${pageSize}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      status,
    },
  })
}

export const getStudyGroups = (search) => {
  const url = `/api/v1/teacher/study-groups/?title=${search}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getMockTestDisciplines = (search) => {
  const url = `/api/v1/fields/?search=${search}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getMockTestSubjects = (search, discipline) => {
  const url = `/api/v1/subjects/?search=${search}&field=${discipline}`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getMockTestById = (id) => {
  const url = `/api/v1/teacher/test/${id}/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const createMockTest = (data) => {
  const url = '/api/v1/teacher/test/'
  return api.post(url, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const editMockTest = ({ id, data }) => {
  const url = `/api/v1/teacher/test/${id}/`
  return api.put(url, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getMockTestQuestions = ({
  id,
  page,
  pageSize,
  field,
  subject,
  seeSelectedQuestions,
}) => {
  const url = `/api/v1/teacher/tests/${id}/questions/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      page,
      field,
      subject,
      page_size: pageSize,
      included_in_test: seeSelectedQuestions,
    },
  })
}

export const addMockTestQuestion = ({ questionId, mockTestId }) => {
  const url = `/api/v1/teacher/tests/${mockTestId}/questions/add/`
  return api.post(
    url,
    {
      question_id: questionId,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': `${getBrowserLanguage()}`,
      },
    },
  )
}

export const removeMockTestQuestion = ({ questionId, mockTestId }) => {
  const url = `/api/v1/teacher/tests/${mockTestId}/questions/remove/`
  return api.post(
    url,
    {
      question_id: questionId,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': `${getBrowserLanguage()}`,
      },
    },
  )
}

// Ações disponíveis: cancel, finalize e clone
export const mockTestAction = ({ id, action }) => {
  const url = `/api/v1/teacher/test/${id}/${action}/`
  return api.post(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Accept-Language': `${getBrowserLanguage()}`,
      },
    },
  )
}

export const getMockTestConfig = () => {
  const url = '/api/v1/teacher/test/configs/'
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getSubjectsReports = (
  page = 1,
  search = null,
  academy = null,
  studyGroupClass = null,
  student = null,
  role = null,
) => {
  const url = `/api/v1/reports/subjects/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      page,
      search,
      academy,
      study_group: studyGroupClass,
      student,
      role,
    },
  })
}

export const getSubjectsReportsKpis = (
  academy = null,
  studyGroup = null,
  student = null,
  role = null,
) => {
  const url = `/api/v1/reports/subjects/kpis/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      academy,
      study_group: studyGroup,
      student,
      role,
    },
  })
}

export const getAcademies = (role = null) => {
  const url = `/api/v1/academies/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      role,
    },
  })
}

export const getStudyGroupClasses = (academy = null, role = null) => {
  const url = `/api/v1/study-groups/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      academy,
      role,
    },
  })
}

export const getStudents = (academy = null, studyGroup = null, role = null) => {
  const url = `/api/v1/students/`
  return api.get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      academy,
      study_group: studyGroup,
      role,
    },
  })
}

export const getSubjectQuestions = ({
  subjectId,
  page = 1,
  pageSize = 10,
  student = null,
  studyGroup = null,
}) => {
  return api.get(`/api/v1/subject/${subjectId}/questions/`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      page,
      page_size: pageSize,
      student,
      study_group: studyGroup,
    },
  })
}

export const getTestResultDashboard = ({ testId }) => {
  return api.get(`/api/v1/reports/test/${testId}/results/`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getTestStudentResultDashboard = ({ testId, studentId }) => {
  return api.get(`/api/v1/reports/test/${testId}/student/${studentId}/results/`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
  })
}

export const getQuestionAnswers = async ({
  questionId,
  page = 1,
  pageSize = 10,
  student,
  studyGroup,
}) => {
  return await api.get(`api/v1/questions/${questionId}/answers/`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Accept-Language': `${getBrowserLanguage()}`,
    },
    params: {
      page,
      page_size: pageSize,
      student,
      study_group: studyGroup,
    },
  })
}

const getBrowserLanguage = () => {
  return i18n.language
}

export default api
